const PRIMARY_COLOR = '#EC7601';
const WHITE = '#FFFFFF';
const BTN_COLOR = 'linear-gradient(180deg, #F9B200 0%, #EC7601 100%)';
const NAVBAR_COLOR = 'linear-gradient(180deg, #EC7601 0%, #F9C701 100%)';
const APPBAR_COLOR = 'transparent';

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    backgroundColor: WHITE,
    appbarColor: APPBAR_COLOR,
    navbarColor: NAVBAR_COLOR,
    buttonColor: BTN_COLOR,
    buttonHoverColor: BTN_COLOR,
}

export default lightTheme;